import 'slick-carousel';
export default {
  init() {
    if ($(window).width() < 768) {
      $('.reviews-slider-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('.slick-reviews-prev'),
        nextArrow: $('.slick-reviews-next'),
        dots: true,
        adaptiveHeight: true,
      });
    } else {
      $('.reviews-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('.slick-reviews-prev'),
        nextArrow: $('.slick-reviews-next'),
        dots: true,
        adaptiveHeight: true,
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-reviews.js